import { render, staticRenderFns } from "./sale-payment.vue?vue&type=template&id=0ffd015c&scoped=true&"
import script from "./sale-payment.vue?vue&type=script&lang=js&"
export * from "./sale-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffd015c",
  null
  
)

export default component.exports